export const APP_NAME = 'Backups.so'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const NOTION_AUTH_URL = 'https://api.notion.com/v1/oauth/authorize?client_id=d9192303-12f4-46fe-812c-c42e35bc0d88&response_type=code&owner=user&redirect_uri=https%3A%2F%2Fapp.backups.so%2Fauth%2Fnotion'
